<script setup>
const props = defineProps({
  coin: { type: Object, default: {} },
});

const { formatMoneyWithCurrency, moneyFormater } = useMoneyFormater();
const { addProductToCart, isInCart } = useCart(props.coin);
</script>

<template>
  <div class="grid grid-cols gap-3">
    <img
      :src="coin.obverse.url"
      class="w-25 h-25 mx-auto object-cover hidden md:block"
    />
    <div class="flex justify-center lg:pt-2 items-center md:hidden flex-col">
      <div class="relative w-25 h-25 overflow-hidden rounded-full">
        <img
          loading="lazy"
          :src="coin.obverse.url"
          :alt="coin.obverse.caption"
          class="front-side coinData_image w-25 h-25 mx-auto object-cover"
        />
        <img
          loading="lazy"
          :src="coin.reverse.url"
          :alt="coin.reverse.caption"
          class="rear-side coinData_image w-25 h-25 mx-auto object-cover"
        />
      </div>
      <div class="dots flex flex-row !space-x-[2px] mt-[6px]">
        <span></span>
        <span></span>
      </div>
    </div>
    <p class="text-sm cardTitle font-firasans text-[#333333]">
      {{ coin.title }}
    </p>
    <div class="hidden md:block text-base md:text-xl mt-auto font-sans">
      {{ formatMoneyWithCurrency(coin.price) }}
    </div>
    <div class="mt-auto flex flex-row items-center justify-between">
      <div class="text-base md:hidden md:text-xl font-sans">
        {{ formatMoneyWithCurrency(coin.price) }}
      </div>
      <template v-if="coin.count > 0">
        <a-icon-basket-add
          v-if="!isInCart"
          @click="addProductToCart"
          class="w-8 h-6 md:w-9 md:h-7 cursor-pointer"
        ></a-icon-basket-add>
        <a-icon-basket-check
          class="w-8 h-6 md:w-9 md:h-7 cursor-pointer"
          v-else
        ></a-icon-basket-check>
      </template>

      <nuxt-link
        :to="localePath(`/coins/${coin.id}`)"
        class="hidden ml-auto md:block w-[29px] h-[29px]"
        ><a-icon-arrow-rounded class="w-[29px] h-[29px]"></a-icon-arrow-rounded>
      </nuxt-link>
    </div>
  </div>
</template>

<style scoped>
.cardTitle {
  display: block;
  display: -webkit-box;
  height: 45px;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media screen and (max-width: 768px) {
  .cardTitle {
    display: block;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 32px;
  }
}
</style>
